const PLURAL = new Intl.PluralRules("en-GB");

/** A count with its noun, as English has it: "1 issue", "3 issues", "0 issues". */
export function counted(count: number, [one, many]: readonly [string, string]): string {
  return `${formatNumber(count)} ${PLURAL.select(count) === "one" ? one : many}`;
}

/** A number as people read it: whole numbers plainly, fractions to one place ("2.5"), thousands grouped. */
export function formatNumber(value: number): string {
  return new Intl.NumberFormat("en-GB", { maximumFractionDigits: 1 }).format(value);
}

/** A string's `{placeholders}` filled in. */
export function fill(template: string, values: Readonly<Record<string, string | number>>): string {
  return template.replace(/\{(\w+)\}/g, (whole, name: string) =>
    name in values ? String(typeof values[name] === "number" ? formatNumber(values[name]) : values[name]) : whole,
  );
}
